export default __webpack_public_path__ + "static/media/mediapicture.3cfab38b.jpg";